"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FETCHED_USER_ENTITLEMENTS = exports.NOTIFICATION_FILTERS_FETCHED = exports.FILTERED_ANNOUNCEMENT_FETCHED = exports.SET_LAST_SEEN_ANNOUNCEMENT_TS = exports.SET_LAST_ANNOUNCEMENT_TS = exports.ANNOUNCEMENTS_FETCHED = exports.PAGINATED_FILTEREDNOTIFICATION_FETCHED = exports.FILTERED_NOTIFICATIONS_FETCHED = exports.MARK_ALL_REMINDERS_AS_SHOWN = exports.MARK_REMINDER_AS_SHOWN = exports.REMINDERS_FETCHED = exports.ACTIVE_TAB_INDEX_CHANGED = exports.ACTIVE_IMS_ORG_CHANGED = exports.NOTIFICATION_URL_LINK_VALIDATION = exports.REMOVE_REMINDER_ON_NOTIFICATION = exports.NOTIFICATIONS_UPDATED = exports.SET_REMINDER_ON_NOTIFICATION = exports.MARK_NOTIFICATION_AS_UNREAD = exports.TOGGLE_NOTIFICATION_READ_STATUS = exports.SET_LAST_NOTIFICATION_SEEN_TIMESTAMP = exports.SET_FLYOUT_LAST_CLOSE_TIMESTAMP = exports.SET_FLYOUT_LAST_OPEN_TIMESTAMP = exports.MARK_ALL_NOTIFICATION_AS_READ = exports.MARK_NOTIFICATION_AS_READ = exports.SET_LAST_USER_CLICK_TIMESTAMP = exports.MARK_NOTIFICATIONS_AS_SHOWN = exports.LATEST_SERVER_TIMESTAMP_FETCHED = exports.LONG_POLL_NOTIFICATIONS_FETCHED = exports.NOTIFICATIONS_FETCHED = exports.NOTIFICATIONS_CONFIG_FETCHED = void 0;

/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************/
var NOTIFICATIONS_CONFIG_FETCHED = 'notifications.NOTIFICATIONS_CONFIG_FETCHED';
exports.NOTIFICATIONS_CONFIG_FETCHED = NOTIFICATIONS_CONFIG_FETCHED;
var NOTIFICATIONS_FETCHED = 'notifications.NOTIFICATIONS_FETCHED';
exports.NOTIFICATIONS_FETCHED = NOTIFICATIONS_FETCHED;
var LONG_POLL_NOTIFICATIONS_FETCHED = 'notifications.LONG_POLL_NOTIFICATIONS_FETCHED';
exports.LONG_POLL_NOTIFICATIONS_FETCHED = LONG_POLL_NOTIFICATIONS_FETCHED;
var LATEST_SERVER_TIMESTAMP_FETCHED = 'notfications.LATEST_SERVER_TIMESTAMP_FETCHED';
exports.LATEST_SERVER_TIMESTAMP_FETCHED = LATEST_SERVER_TIMESTAMP_FETCHED;
var MARK_NOTIFICATIONS_AS_SHOWN = 'notifications.MARK_NOTIFICATIONS_AS_SHOWN';
exports.MARK_NOTIFICATIONS_AS_SHOWN = MARK_NOTIFICATIONS_AS_SHOWN;
var SET_LAST_USER_CLICK_TIMESTAMP = 'notifications.SET_LAST_USER_CLICK_TIMESTAMP';
exports.SET_LAST_USER_CLICK_TIMESTAMP = SET_LAST_USER_CLICK_TIMESTAMP;
var MARK_NOTIFICATION_AS_READ = 'notifications.MARK_NOTIFICATION_AS_READ';
exports.MARK_NOTIFICATION_AS_READ = MARK_NOTIFICATION_AS_READ;
var MARK_ALL_NOTIFICATION_AS_READ = 'notifications.MARK_ALL_NOTIFICATION_AS_READ';
exports.MARK_ALL_NOTIFICATION_AS_READ = MARK_ALL_NOTIFICATION_AS_READ;
var SET_FLYOUT_LAST_OPEN_TIMESTAMP = 'notifications.SET_FLYOUT_LAST_OPEN_TIMESTAMP';
exports.SET_FLYOUT_LAST_OPEN_TIMESTAMP = SET_FLYOUT_LAST_OPEN_TIMESTAMP;
var SET_FLYOUT_LAST_CLOSE_TIMESTAMP = 'notifications.SET_FLYOUT_LAST_CLOSE_TIMESTAMP';
exports.SET_FLYOUT_LAST_CLOSE_TIMESTAMP = SET_FLYOUT_LAST_CLOSE_TIMESTAMP;
var SET_LAST_NOTIFICATION_SEEN_TIMESTAMP = 'notifications.SET_LAST_NOTIFICATION_SEEN_TIMESTAMP';
exports.SET_LAST_NOTIFICATION_SEEN_TIMESTAMP = SET_LAST_NOTIFICATION_SEEN_TIMESTAMP;
var TOGGLE_NOTIFICATION_READ_STATUS = 'notifications.TOGGLE_NOTIFICATION_READ_STATUS';
exports.TOGGLE_NOTIFICATION_READ_STATUS = TOGGLE_NOTIFICATION_READ_STATUS;
var MARK_NOTIFICATION_AS_UNREAD = 'notifications.MARK_NOTIFICATION_AS_UNREAD';
exports.MARK_NOTIFICATION_AS_UNREAD = MARK_NOTIFICATION_AS_UNREAD;
var SET_REMINDER_ON_NOTIFICATION = 'notifications.SET_REMINDER_ON_NOTIFICATION';
exports.SET_REMINDER_ON_NOTIFICATION = SET_REMINDER_ON_NOTIFICATION;
var NOTIFICATIONS_UPDATED = 'notifications.NOTIFICATIONS_UPDATED';
exports.NOTIFICATIONS_UPDATED = NOTIFICATIONS_UPDATED;
var REMOVE_REMINDER_ON_NOTIFICATION = 'notifications.REMOVE_REMINDER_ON_NOTIFICATION';
exports.REMOVE_REMINDER_ON_NOTIFICATION = REMOVE_REMINDER_ON_NOTIFICATION;
var NOTIFICATION_URL_LINK_VALIDATION = 'notifications.NOTIFICATION_URL_LINK_VALIDATION';
exports.NOTIFICATION_URL_LINK_VALIDATION = NOTIFICATION_URL_LINK_VALIDATION;
var ACTIVE_IMS_ORG_CHANGED = 'notifications.ACTIVE_IMS_ORG_CHANGED';
exports.ACTIVE_IMS_ORG_CHANGED = ACTIVE_IMS_ORG_CHANGED;
var ACTIVE_TAB_INDEX_CHANGED = 'notifications.ACTIVE_TAB_INDEX_CHANGED';
exports.ACTIVE_TAB_INDEX_CHANGED = ACTIVE_TAB_INDEX_CHANGED;
var REMINDERS_FETCHED = 'reminders.REMINDERS_FETCHED';
exports.REMINDERS_FETCHED = REMINDERS_FETCHED;
var MARK_REMINDER_AS_SHOWN = 'reminders.MARK_REMINDER_AS_SHOWN';
exports.MARK_REMINDER_AS_SHOWN = MARK_REMINDER_AS_SHOWN;
var MARK_ALL_REMINDERS_AS_SHOWN = 'reminders.MARK_ALL_REMINDERS_AS_SHOWN';
exports.MARK_ALL_REMINDERS_AS_SHOWN = MARK_ALL_REMINDERS_AS_SHOWN;
var FILTERED_NOTIFICATIONS_FETCHED = 'filteredNotifications.FILTERED_NOTIFICATIONS_FETCHED';
exports.FILTERED_NOTIFICATIONS_FETCHED = FILTERED_NOTIFICATIONS_FETCHED;
var PAGINATED_FILTEREDNOTIFICATION_FETCHED = 'filteredNotifications.PAGINATED_FILTEREDNOTIFICATION_FETCHED';
exports.PAGINATED_FILTEREDNOTIFICATION_FETCHED = PAGINATED_FILTEREDNOTIFICATION_FETCHED;
var ANNOUNCEMENTS_FETCHED = 'announcements.ANNOUNCEMENTS_FETCHED';
exports.ANNOUNCEMENTS_FETCHED = ANNOUNCEMENTS_FETCHED;
var SET_LAST_ANNOUNCEMENT_TS = 'announcements.SET_LAST_ANNOUNCEMENT_TS'; //SET_LAST_SEEN_ANNOUNCEMENT_TS is created as to handle New and Earlier Section headers
// whereas SET_LAST_ANNOUNCEMENT_TS is handling the blue dot which goes away on mount

exports.SET_LAST_ANNOUNCEMENT_TS = SET_LAST_ANNOUNCEMENT_TS;
var SET_LAST_SEEN_ANNOUNCEMENT_TS = 'announcements.SET_LAST_SEEN_ANNOUNCEMENT_TS';
exports.SET_LAST_SEEN_ANNOUNCEMENT_TS = SET_LAST_SEEN_ANNOUNCEMENT_TS;
var FILTERED_ANNOUNCEMENT_FETCHED = 'announcements.FILTERED_ANNOUNCEMENT_FETCHED';
exports.FILTERED_ANNOUNCEMENT_FETCHED = FILTERED_ANNOUNCEMENT_FETCHED;
var NOTIFICATION_FILTERS_FETCHED = 'notifications.NOTIFICATION_FILTERS';
exports.NOTIFICATION_FILTERS_FETCHED = NOTIFICATION_FILTERS_FETCHED;
var FETCHED_USER_ENTITLEMENTS = 'announcements.FETCHED_USER_ENTITLEMENTS';
exports.FETCHED_USER_ENTITLEMENTS = FETCHED_USER_ENTITLEMENTS;